<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'common.new-contact'">_Nuevo contacto</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__form-container-extend">
    <div class="common-tag__mandatory-obligatory-message-right">
      <span class="common-tag__mandatory-text-asterisk">*</span>
      <span class="common-tag__mandatory-label-text-obligatory-message"
        [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
    </div>
    <div class="new-contact__row-form">
      <field-type-text-simple
        [field]="newContact.name"
        [preSelectItem]="newContact.new.name"
        (itemSelected)="itemSelected('name', $event.newValue)" >
      </field-type-text-simple>
      <field-type-text-simple [ngClass]="{'min-w-[435px]': skin !== 'uk-steel-blue'}"
        [field]="newContact.surname"
        [preSelectItem]="newContact.new.surname"
        (itemSelected)="itemSelected('surname', $event.newValue)" >
      </field-type-text-simple>
      @if (skin !== 'uk-steel-blue') {
          <field-type-text-simple
            [field]="newContact.nif"
            [preSelectItem]="newContact.new.nif"
            (itemSelected)="itemSelected('nif', $event.newValue)" >
          </field-type-text-simple>
      }
    </div>
    <div class="new-contact__row-form">
      <field-type-text-simple
        [field]="newContact.position"
        [preSelectItem]="newContact.new.position"
        (itemSelected)="itemSelected('position', $event.newValue)" >
      </field-type-text-simple>
      <field-type-text-simple
        [field]="newContact.companyname"
        [preSelectItem]="newContact.new.companyname"
        (itemSelected)="itemSelected('companyname', $event.newValue)" >
      </field-type-text-simple>
    </div>
    <div class="new-contact__row-form">
      <field-type-text-simple [ngClass]="{'min-w-[298px]': skin !== 'uk-steel-blue'}"
        [field]="newContact.address"
        [preSelectItem]="newContact.new.address"
        (itemSelected)="itemSelected('address', $event.newValue)" >
      </field-type-text-simple>
      <field-type-number
        [field]="newContact.postalCode"
        [preSelectItem]="newContact.new.postalCode"
        (itemSelected)="itemSelected('postalCode', $event.newValue)">
      </field-type-number>
      <field-type-text-simple
        [field]="newContact.city"
        [preSelectItem]="newContact.new.city"
        (itemSelected)="itemSelected('city', $event.newValue)" >
      </field-type-text-simple>
      @if (skin !== 'uk-steel-blue') {
        <field-type-text-simple
          [field]="newContact.province"
          [preSelectItem]="newContact.new.province"
          (itemSelected)="itemSelected('province', $event.newValue)" >
        </field-type-text-simple>
      }
    </div>
    <div class="new-contact__row-form">
      @if (skin !== 'uk-steel-blue') {
        <field-type-text-simple
          [field]="newContact.country"
          [preSelectItem]="newContact.new.country"
          (itemSelected)="itemSelected('country', $event.newValue)" >
        </field-type-text-simple>
      }
      <field-type-text-simple [ngClass]="{'min-w-[298px]': skin !== 'uk-steel-blue'}"
        [field]="newContact.email"
        [preSelectItem]="newContact.new.email"
        (itemSelected)="itemSelected('email', $event.newValue)" >
      </field-type-text-simple>
      <field-type-text-simple
        [field]="newContact.phonenumber1"
        [preSelectItem]="newContact.new.phonenumber1"
        (itemSelected)="itemSelected('phonenumber1', $event.newValue)" >
      </field-type-text-simple>
      <field-type-text-simple
        [field]="newContact.phonenumber2"
        [preSelectItem]="newContact.new.phonenumber2"
        (itemSelected)="itemSelected('phonenumber2', $event.newValue)" >
      </field-type-text-simple>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
        (click)="createNew()">
        <span class="common-button__text-title"
            [afTranslate]="'common.add'">_Añadir</span>
    </button>
  </div>
</div>
